interface Props {
  onClick: () => void
}

export const CloseButton: React.FC<Props> = ({ onClick }) => {
  return (
    <div className="relative p-[10px] font-medium text-right text-white bg-[#4a85c7] border-l-[10px] border-[#3069b0]">
      <button
        type="button"
        className="py-[5px] px-[10px] mt-2 mr-[10px] text-sm font-bold leading-4 text-[#cfdef0] rounded-2xl border border-[#86b1e2] border-solid cursor-pointer"
        onClick={onClick}
      >
        x 閉じる
      </button>
    </div>
  )
}
